import * as OverviewActions from './tasks-overview.actions';
import { Action, createReducer, on } from '@ngrx/store';
import { IOverview } from '../models/overview.model';

export type State = IOverview;

const initialState: State = {
  tasks: null,
  taskStats: null,
  files: null,
  checks: null,
  checkOutcomes: null
};

const overviewReducer = createReducer(
  initialState,
  on(OverviewActions.ClearState, (): State => initialState),

  on(OverviewActions.GetAnalysisTasksSuccess, (state, { tasks, analysisId }): State => {
    return { ...state, tasks: { ...state.tasks, [analysisId]: tasks } };
  }),

  on(OverviewActions.GetAnalysisCheckOutcomesSuccess, (state, { checkOutcomes, analysisId }): State => {
    return { ...state, checkOutcomes: { ...state.checkOutcomes, [analysisId]: checkOutcomes } };
  }),

  on(OverviewActions.GetAnalysesFilesSuccess, (state, { files }): State => {
    return { ...state, files };
  }),

  on(OverviewActions.GetChecksSuccess, (state, { checks }): State => {
    return { ...state, checks };
  }),

  on(OverviewActions.GetAnalysesTaskStatsSuccess, (state, { taskStats }): State => {
    return { ...state, taskStats };
  })
);

export const reducer = (state: State, action: Action): State => overviewReducer(state, action);
